/* eslint-disable */
var $ = window.jQuery = require('jquery');
import toast from '../../../services/toast';
import { mapGetters } from 'vuex';

export default {
  name: 'contest-quiz-feedback',
  components: {},
  props: [],
  data() {
    return {
      quizData:{
        quizId:''
      },
      coursesId:'',
      quizQuesDetails:'',
      quizFeedbackList:'',
      pub_catID:'',
      nextStep: '',
      totalCount: '',
      loadmoreData: {},
    }
  },
  computed: {
    ...mapGetters([
      'getQuizDetailsByIdDataState',
      'getFeedbackOfContestGetters'
    ]),
    getQuizQuesDetails() {
      this.quizQuesDetails = this.$store.getters.getQuizDetailsByIdDataState
      return this.quizQuesDetails
    },
    getQuizzesFeedbackFun(){
      this.quizFeedbackList = this.$store.getters.getFeedbackOfContestGetters.data
      return this.quizFeedbackList
    },
    SetIntialStatus() {
      if (this.quizFeedbackList != undefined) {
        this.totalCount = this.quizFeedbackList.count
        this.nextStep = this.quizFeedbackList.next
        this.quizFeedbackListResults = this.quizFeedbackList.results
      }
    }
  },
  mounted() {
    this.pub_catID = this.$route.params.quiz_catId,
    this.getQuizzesFeedbackFun
    this.getQuizQuesDetails
    this.SetIntialStatus
    this.quizData.quizId = this.$route.params.quizId;
  },
  methods: {
    loadmoreUser(url) {
      this.userLoading = true
      axios.get(url)
        .then((response) => {
          this.loadmoreData = response.data
          this.nextStep = this.loadmoreData.data.next
          this.$set(this.quizFeedbackList, 'next', this.nextStep)
          if (this.loadmoreData != undefined) {
            for (var i = 0; i < this.loadmoreData.data.results.length; i++) {
              this.quizFeedbackListResults.push(this.loadmoreData.data.results[i]);
              this.userLoading = false
            }
          }
        });
    },
  },
  beforeMount() {
  },
  watch: {
    getQuizQuesDetails() {
      return this.$store.getters.getQuizDetailsByIdDataState
    },
    getQuizzesFeedbackFun(){
      return this.$store.getters.getFeedbackOfContestGetters
    },
    SetIntialStatus() {
      if (this.quizFeedbackList != undefined) {
        this.totalCount = this.quizFeedbackList.count
        this.nextStep = this.quizFeedbackList.next
        this.quizFeedbackListResults = this.quizFeedbackList.results
      }
    }
  },
}